export const units = {
  splice(val) {
    let innerVal = typeof val === 'number' ? val + 'px' : val
    innerVal = /^\d+$/.test(innerVal) ? innerVal + 'px' : innerVal
    return innerVal
  }
}
